
/* injects from baggage-loader */

'use strict';

import AboutComponent from './about.component';
import '../home/home.scss';

const AboutPageModule = angular.module('about-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('about', {
        url: '/about',
        component: 'about',
        transparent_nav: true
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('about', new AboutComponent());

export default AboutPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/about/about.module.js